//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Sections from 'components/globalBlocks/Sections.vue'

// Can likely reduce the section layer
// import SubSections from 'components/combinedBlocks/SubSections.vue'

import FixedContainer from 'components/globalBlocks/FixedContainer.vue'

import FixedSections from 'components/globalBlocks/FixedSections.vue'
import ScrolledSections from 'components/globalBlocks/ScrolledSections.vue'

// import LanguageSelector from 'components/blocks/LanguageSelector.vue'
import SpotinHeader from 'fixed/Header.vue'
import SpotinFooter from 'components/globalBlocks/Footer.vue'

import { mapGetters } from 'vuex'


export default {
  block: 'website',
  computed: {
    ...mapGetters([
      'isFetchingData'
    ])
  },
  components: {
    // Logo,
    SpotinHeader,
    SpotinFooter,
    // SubSections,
    Sections,
    FixedSections,
    ScrolledSections,
    FixedContainer,
    // LanguageSelector,
  },
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/Website.vue